import $ from 'jquery'
import manager from '../manager'
import { formatPrice } from '@/utils/currency'
import { getPrice,getSpuPrice } from '@/api/price'
import translate from '@/utils/translate'
import Queue from '@/utils/queue'
import _ from 'lodash'

const spuQueue=new Queue(getSpuPrice)

manager.add('spuPrice', {
	async created(id) {
		if(!id)return
		var price = (await spuQueue.get(id))||{}
		var showPrice=formatPrice(price.lprice,price.hprice)
		if(!showPrice){
			$(this.dom).text(translate('Unavailable'))
		}else{
			$(this.dom).text(showPrice)
		}
	}
})

const skuQueue=new Queue(getPrice)

manager.add('skuPrice', {
	async created(id) {
		if(!id)return
		var price = (await skuQueue.get(id))||{}
		var discount=price.discountPrice&&price.discountPrice>-1?price.discountPrice:price.jdPrice
		var showPrice=formatPrice(discount)
		if(!showPrice){
			$(this.dom).text(translate('Unavailable'))
		}else{
			$(this.dom).text(showPrice)
		}
	
	}
})

manager.add('skuOriginPrice', {
	async created(id) {
		if(!id)return
		var price = (await skuQueue.get(id))||{}
		if(!price.discountPrice||price.discountPrice<0){
			return 
		}
		if(parseFloat(price.discountPrice)>=parseFloat(price.jdPrice)){
			return
		}
		let showPrice=formatPrice(price.jdPrice)
		if(!showPrice){
			return
		}
		$(this.dom).text(showPrice)	
	}
})

manager.add('skuDiscount', {
	async created(id) {
		if(!id)return
		var price = (await skuQueue.get(id))||{}
		var discount=price.discount
		if(!discount||discount==0){
			$(this.dom).hide()
			return
		}
		$(this.dom).show().find(".number").text(discount)
	}
})

manager.add('maxSkuDiscount', {
	async created(ids) {
		if(!ids||!ids.length)return
		var discounts=await Promise.all(ids.map(id=>this.getDiscount(id)))
		var discount=Math.max.apply(null, _.compact(discounts))
		if(!discount||discount==0||discount==-Infinity){
			$(this.dom).hide()
			return
		}
		$(this.dom).show().find(".number").text(discount)
	},
	async getDiscount(id){
		var price = (await skuQueue.get(id))||{}
		return price.discount
	}
})

manager.add('formatPrice', {
	created(price) {
		var showPrice=formatPrice(price)
		if(!showPrice){
			$(this.dom).text(translate('Unavailable'))
		}else{
			$(this.dom).text(showPrice)
		}
	}
})